import React from "react";
import "./TopBar.css";

import { ReactComponent as SearchIcon } from "../../../assets/search.svg";
import { ReactComponent as LightIcon } from "../../../assets/light.svg";
import { ReactComponent as NotificationIcon } from "../../../assets/notification.svg";

import { useTheme } from "../../ThemeContext";

const titles = {
  dashboard: "Dashboard",
  testposts: "Test Posts",
  createtest: "Create Test",
  candidates: "Candidates",
  rankings: "Rankings",
  messages: "Messages",
  settings: "Settings",
};

export default function TopBar({ page }) {
  const { isDark, toggleTheme } = useTheme();

  return (
    <header className="topbar">

      {/* LEFT */}
      <div className="topbar-left">
        <h3>{titles[page] || "Dashboard"}</h3>
      </div>

      {/* RIGHT */}
      <div className="topbar-right">

        {/* SEARCH */}
        <div className="topbar-search">
          <SearchIcon className="search-icon" />
          <input placeholder="Search candidates, jobs, tests..." />
        </div>

        {/* ICONS */}
        <div className="topbar-icons">
          <button className="icon-btn" onClick={toggleTheme} title="Toggle Theme" style={{ fontSize: "14px" }}>
            {isDark ? "☀️" : "🌙"}
          </button>

          <button className="icon-btn">
            <NotificationIcon className="icon-color" />
          </button>
        </div>

        {/* PROFILE */}
        <div className="topbar-profile">
          <span>AT</span>
        </div>

      </div>
    </header>
  );
}